import { AdminProfessionalSpecializations } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints РґР»СЏ admin-backend /professional-specializations/*.
 *
 * Authz: super_admin only. Р’СЃРµ РѕС‚РІРµС‚С‹ РїР°СЂСЃСЏС‚СЃСЏ С‡РµСЂРµР· Zod вЂ”
 * drift backendв†”frontend РїР°РґР°РµС‚ РіСЂРѕРјРєРѕ.
 */
export const professionalSpecializationsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listAdminProfessionalSpecializations: build.query<
            AdminProfessionalSpecializations.GetAdminProfessionalSpecializationsResponse,
            AdminProfessionalSpecializations.GetAdminProfessionalSpecializationsRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.parentId !== undefined) {
                    search.parentId = params.parentId;
                }
                if (params?.isActive !== undefined) {
                    search.isActive = params.isActive ? 'true' : 'false';
                }
                if (params?.q !== undefined && params.q !== '') {
                    search.q = params.q;
                }
                return {
                    url: '/professional-specializations',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (
                raw: unknown
            ): AdminProfessionalSpecializations.GetAdminProfessionalSpecializationsResponse =>
                parseWithSchema(
                    AdminProfessionalSpecializations.GetAdminProfessionalSpecializationsResponseSchema,
                    raw
                ),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((s) => ({
                            type: 'ProfessionalSpecialization' as const,
                            id: s.id
                        })),
                        { type: 'ProfessionalSpecialization' as const, id: 'LIST' }
                    ]
                    : [{ type: 'ProfessionalSpecialization' as const, id: 'LIST' }]
        }),

        createAdminProfessionalSpecialization: build.mutation<
            AdminProfessionalSpecializations.CreateAdminProfessionalSpecializationResponse,
            AdminProfessionalSpecializations.CreateAdminProfessionalSpecializationRequest
        >({
            query: (body) => ({
                url: '/professional-specializations',
                method: 'POST',
                body
            }),
            transformResponse: (
                raw: unknown
            ): AdminProfessionalSpecializations.CreateAdminProfessionalSpecializationResponse =>
                parseWithSchema(
                    AdminProfessionalSpecializations.CreateAdminProfessionalSpecializationResponseSchema,
                    raw
                ),
            invalidatesTags: [{ type: 'ProfessionalSpecialization', id: 'LIST' }]
        }),

        updateAdminProfessionalSpecialization: build.mutation<
            AdminProfessionalSpecializations.UpdateAdminProfessionalSpecializationResponse,
            AdminProfessionalSpecializations.UpdateAdminProfessionalSpecializationRequest
        >({
            query: ({ id, ...body }) => ({
                url: `/professional-specializations/${id}`,
                method: 'PATCH',
                body
            }),
            transformResponse: (
                raw: unknown
            ): AdminProfessionalSpecializations.UpdateAdminProfessionalSpecializationResponse =>
                parseWithSchema(
                    AdminProfessionalSpecializations.UpdateAdminProfessionalSpecializationResponseSchema,
                    raw
                ),
            invalidatesTags: (_result, _error, arg) => [
                { type: 'ProfessionalSpecialization', id: arg.id },
                { type: 'ProfessionalSpecialization', id: 'LIST' }
            ]
        }),

        deleteAdminProfessionalSpecialization: build.mutation<
            AdminProfessionalSpecializations.DeleteAdminProfessionalSpecializationResponse,
            AdminProfessionalSpecializations.DeleteAdminProfessionalSpecializationRequest
        >({
            query: ({ id }) => ({
                url: `/professional-specializations/${id}`,
                method: 'DELETE'
            }),
            transformResponse: (
                raw: unknown
            ): AdminProfessionalSpecializations.DeleteAdminProfessionalSpecializationResponse =>
                parseWithSchema(
                    AdminProfessionalSpecializations.DeleteAdminProfessionalSpecializationResponseSchema,
                    raw
                ),
            invalidatesTags: (_result, _error, arg) => [
                { type: 'ProfessionalSpecialization', id: arg.id },
                { type: 'ProfessionalSpecialization', id: 'LIST' }
            ]
        }),

        reorderAdminProfessionalSpecializations: build.mutation<
            AdminProfessionalSpecializations.ReorderAdminProfessionalSpecializationsResponse,
            AdminProfessionalSpecializations.ReorderAdminProfessionalSpecializationsRequest
        >({
            query: (body) => ({
                url: '/professional-specializations/reorder',
                method: 'POST',
                body
            }),
            transformResponse: (
                raw: unknown
            ): AdminProfessionalSpecializations.ReorderAdminProfessionalSpecializationsResponse =>
                parseWithSchema(
                    AdminProfessionalSpecializations.ReorderAdminProfessionalSpecializationsResponseSchema,
                    raw
                ),
            invalidatesTags: [{ type: 'ProfessionalSpecialization', id: 'LIST' }]
        })
    })
});

export const {
    useListAdminProfessionalSpecializationsQuery,
    useCreateAdminProfessionalSpecializationMutation,
    useUpdateAdminProfessionalSpecializationMutation,
    useDeleteAdminProfessionalSpecializationMutation,
    useReorderAdminProfessionalSpecializationsMutation
} = professionalSpecializationsApi;
